import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
import useGetLogo from "./hooks/use-logo";
import dark from "src/images/logodark.png";
import light from "src/images/logolight.png";
import { useTheme } from "@mui/material";
const Logo = ({ disabledLink = false }) => {
  const logo = useGetLogo();
  const { palette } = useTheme();
  const isDark = palette.mode === "dark";
  if (disabledLink) {
    return (
      <img
        style={{ width: "180px", height: "auto", maxHeight: "64px" }}
        src={logo}
      />
    );
  }

  return (
    <RouterLink to="/">
      <img
        style={{ width: "180px", height: "auto" }}
        src={logo}
      />
    </RouterLink>
  );
};

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default Logo;
